<div class="w-full px-6 py-8 space-y-10">
    <form [formGroup]="reportForm" (ngSubmit)="onSubmit()" class="space-y-10">
        <div class="bg-white rounded-2xl shadow-lg p-6 space-y-6">
            <div class="flex items-center gap-2 border-b pb-2">
                <div class="w-[4px] h-6 bg-primary"></div>
                <h2 class="text-xl font-semibold text-gray-800">Daily progress (chainage)</h2>
            </div>

            <div class="col-span-12">
                <mat-label>Project</mat-label>
                <mat-form-field appearance="outline">
                    <mat-select formControlName="project_id" (selectionChange)="onProjectChange()">
                        <mat-option *ngFor="let p of projects" [value]="p.id">{{ p.project_name || p.project_identifier || p.id }}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-span-12">
                <mat-label>Work location</mat-label>
                <mat-form-field appearance="outline">
                    <mat-select formControlName="work_location_id">
                        <mat-option *ngFor="let l of locations" [value]="l.id">{{ l.location_name || l.id }}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-span-12">
                <mat-label>Pavement work item</mat-label>
                <mat-form-field appearance="outline">
                    <mat-select formControlName="pavement_work_item_id">
                        <mat-option *ngFor="let w of workItems" [value]="w.id">{{ w.layer_label }} &#64; {{ w.location_name }}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-span-12">
                <mat-label>Report Date</mat-label>
                <mat-form-field appearance="outline">
                    <input matInput [matDatepicker]="picker" formControlName="reportDate">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="col-span-12">
                <mat-label>Work Description</mat-label>
                <mat-form-field appearance="outline">
                    <textarea matInput rows="3" formControlName="workDescription"></textarea>
                </mat-form-field>
            </div>
            <div class="col-span-12">
                <mat-label>Quantity</mat-label>
                <mat-form-field appearance="outline">
                    <input type="number" matInput formControlName="progressPercentage">
                </mat-form-field>
            </div>
            <div class="col-span-12">
                <mat-checkbox formControlName="qualityPassed">Quality Test Passed</mat-checkbox>
                <mat-checkbox formControlName="inspectionDone">Inspection Done</mat-checkbox>
            </div>
            <div class="col-span-12">
                <mat-label>Geotag (optional)</mat-label>
                <mat-form-field appearance="outline">
                    <mat-label>Latitude</mat-label>
                    <input matInput type="number" formControlName="latitude">
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Longitude</mat-label>
                    <input matInput type="number" formControlName="longitude">
                </mat-form-field>
            </div>
            <div class="col-span-12">
                <input type="file" (change)="onFileSelected($event)">
            </div>
            <button mat-raised-button color="primary" type="submit" [disabled]="reportForm.invalid">Submit</button>
        </div>
    </form>
</div>
